import React, {useEffect, useRef, useState, useCallback} from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Col, Container, Modal, Row, Button, Spinner } from 'react-bootstrap';
import MTS_Stops from "../components/MicroTransitSimulationComponents/MTS_Stops";
import RCZControlMap from "../components/Controls/mapControlRCZ"; 
import itcurvesLogo from '../../src/assets/Images/CommonImages/ITClogo.png'
import MTS_SimulationStartInfo from "../components/MicroTransitSimulationComponents/MTS_SimulationStartInfo";
import MTS_EmailVerification from "../components/MicroTransitSimulationComponents/MTS_EmailVerification";
import { useSelector } from "react-redux";
import PropagateLoader from 'react-spinners/PropagateLoader';
import APICom from "../utils/helpers/APICom.js";
import '../assets/Styles/SimulationCSS/SliderSim.css';

const api_url = 'https://demomicrotransitsimapi.itcurves.us/'; // Replace with your actual API URL
const apiKey = 'h2mUZVfEGuZKVOaR218a3KYwxJr6zyc3'; // Replace with your actual API Key


const MicroTransitMySimulation = () => {

    const DefaultSimulationLink = "https://simdispatch.itcurves.us/SimulationScheduler";
    const [savedCoordinates, setSavedCoordinates] = useState("");
    const [addressComponentDataArray, setAddressComponentDataArray] = useState([]);
    const handleAddressComponentDataFromMap = (dataArray) => {
        setAddressComponentDataArray(dataArray);
      };

    const [slotMessageOnEmailVerificationScreen, setSlotMessageOnEmailVerificationScreen] = useState("");
    const SimulationDashboardURL = "https://demo1rmdashboard.itcurves.us/index.html?username=ncs&password=oOFPtMQKKhc=&webmrms=true"; 
    
    const [savedProfileUserName, setSavedProfileUserName] = useState("");
  
    const [savedProfileEncryptedPassword, setSavedProfileEncryptedPassword] = useState("");

    const [savedCustomerProfileID, setSavedCustomerProfileID] = useState("");

    const [savediAssignedAffiliateID, setSavediAssignedAffiliateID] = useState("");

    const xCancelSourceForGrid = useRef(null);
    const [isResetBtnCalled, setIsResetBtnCalled] = useState(false);

    const [showGuideSection, setShowGuideSection] = useState(false);
    const [apiLoading, setAPILoading] = useState(true);
    const [countDownLoading, setCountDownLoading] = useState(false);
    const [apiLoadingMessage, setApiLoadingMessage] = useState("Please wait..");
    const [numberOfTrips, setNumberOfTrips] = useState(100);
    const [numberOfVehicles, setNumberOfVehicles] = useState(10);
    const [slotDuration, setSlotDuration] = useState(60);
    const [email, setEmail] = useState("");
    const [selectedStops, setSelectedStops] = useState(0);
    const [totalStops, setTotalStops] = useState(0);
    const [isBtnDisabled, setIsBtnDisabled] = useState(true);
    
    const [isSlideLeft, setIsSlideLeft] = useState(false);

    const handleSlideLeftButtonClick = (slideIt) => {
        setIsSlideLeft(slideIt);
    };


    const [isSlideRight, setIsSlideRight] = useState(false);

    const handleSlideRightButtonClick = (slideIt) => {
        setIsSlideRight(slideIt);
    };

    const onClickGuideMe = () => {
        try {
            if(showGuideSection == false){
                handleSlideLeftButtonClick(true);
                handleSlideRightButtonClick(true);
                setShowGuideSection(true);

            }
            else{
                handleSlideLeftButtonClick(false);
                handleSlideRightButtonClick(false);
                setShowGuideSection(false);
            }

        } catch (error) {
            
        }
    }

    const resetSearchCityState = () => {
        try {
            setName("");
            setTotalStops(0);
            setInsidePolygonStops([]);
            setStopsDataForPopApi([]);
            setPolygonVertices([])
            setIsResetBtnCalled(true);
        } catch (error) {
            
        }
    }

    useEffect(() => {

        // const handleKeyDown = (event) => {
        //     if (event.key === 'Enter' || event.key === "Tab") {
        //         event.preventDefault(); // Optional: prevent default behavior
        //         getGTFS(); // Call your method
        //     }
        // };
        // window.addEventListener('keydown', handleKeyDown);
        document.title = "My Simulation";

        setApiLoadingMessage("Loading...."); 
        setTimeout(() => {
            setAPILoading(false);
            setApiLoadingMessage(""); 
        }, 2000);
        return () => {
            //window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    //Aqib Code 
     /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    const { GlobalASCSData, DispatchVehicleData, FundingSourceData, ZoneVerticesData } = useSelector((store) => store.combinedata);



    const [mapOptions, setmapOptions] = useState({
        height: 360,
        heightoffset: 105,
        calculateHeight: true,
        pagination: true,
        mapZoomOpts: {zoomControl: false, draggable: true, scrollWheel: true, disableDoubleClickZoom: false},
        mapDefaultBtns: false,
        mapOptions: {tilt: 47.5, zoom: 15, zone: false}
        
    });

    const [name, setName] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [modalContent, setModalContent] = useState('');
    const [folderName, setFolderName] = useState('');
    const [transitName, setTransitName] = useState('');
    const [stopsDataForPopApi, setStopsDataForPopApi] = useState([]);
    const [countyName, setCountyName] = useState('');
    const [stateName, setStateName] = useState('');
    const [populationData, setPopulationData] = useState(null);

    
    const [stops, setStops] = useState([]);
    const [polygonVertices, setPolygonVertices] = useState([]);
    const [insidePolygonStops, setInsidePolygonStops] = useState([]);
    const googleMapComponentRef = useRef(null);



    const onMapDataSave = (updatedPolygonVertices, updatedStops) => {

      console.log('Latest Polygon data', updatedPolygonVertices)
      console.log('Latest Stops Data', updatedStops)
      setTotalStops(updatedStops?.length);
      setInsidePolygonStops(updatedStops);
      setPolygonVertices(updatedPolygonVertices);
      
    //   const insideStops = updatedStops.filter(stop => isPointInPolygon(stop, updatedPolygonVertices));
    //   setInsidePolygonStops(insideStops);


      
      console.log('Removed Stops Data', insidePolygonStops)


    };


    const isPointInPolygon = (point, polygon) => {
      const x = point[1], y = point[0];
      let inside = false;
      for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
        const xi = polygon[i].lng, yi = polygon[i].lat;
        const xj = polygon[j].lng, yj = polygon[j].lat;
        const intersect = ((yi > y) !== (yj > y)) && 
                         (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
        if (intersect) inside = !inside;
      }
      return inside;
    };



    const handleSave = () => {
      if (googleMapComponentRef.current) {
        googleMapComponentRef.current.saveMapData();
      }
    };

    const handleInputChange = (e) => {
      setName(e.target.value);
    };
    
    const [isStopsLoadedFromAPI, setIsStopsLoadedFromAPI] = useState(false);
    useEffect(() => {
        if(isStopsLoadedFromAPI == true){
            setApiLoadingMessage("");
            setAPILoading(false);
        }
    }, [isStopsLoadedFromAPI])

    const [isSearchBtnClicked, setIsSearchBtnClicked] = useState(false);
    const [IsReloadStopsBtnClicked, setIsReloadStopsBtnClicked] = useState(false);
    useEffect(() => {
        if(IsReloadStopsBtnClicked == true){
            setAPILoading(true);
            setApiLoadingMessage("Recomputing stops, please wait...");
        }
        else{
            // setAPILoading(false);
            // setApiLoadingMessage("");
        }
    }, [IsReloadStopsBtnClicked])

    useEffect(() => {
        if(isSearchBtnClicked == true){
            setAPILoading(true);
            setApiLoadingMessage("Computing stops, please wait...");
        }
        else{
            // setAPILoading(false);
            // setApiLoadingMessage("");
        }
    }, [isSearchBtnClicked])
  
    const getGTFS = async () => {
        if(name != undefined && name != ""){
            try {
                setAPILoading(true);
                setApiLoadingMessage("Loading Area...");
                let response = await CheckCityCountyNameValid(name);
                if(response == true){
                    setIsSearchBtnClicked(true);
                }
                else{
                    // setIsSearchBtnClicked(false)
    
                }
            } catch (error) {
                setApiLoadingMessage("");
                setAPILoading(false);
                // setIsSearchBtnClicked(false)
            }
            
        }
    };
  
    const fetchData = async (url, fileAlreadyExists, name) => {
        setAPILoading(true);
        setApiLoadingMessage("Almost Done..");
        setError(null);
        setModalContent('');
  
        try {
            const requestParam = {
            url: url,
            fileAlreadyExists: fileAlreadyExists,
            name: name
            };
    
            const response = await fetch(`${api_url}gtfs`, {method: 'POST',headers: {'Content-Type': 'application/json'},body: JSON.stringify(requestParam)});
    
            if (response.ok) {
                setApiLoadingMessage("Loading Stops..");
                const apiData = await response.json();
                console.log(apiData)
                setFolderName(apiData['folder']);
                setTransitName(apiData['transitName']);
                setStopsDataForPopApi(apiData['stops_data']);
            } else {
                setModalContent('Error occurred while fetching data');
            }
          
        } catch (error) {
            setModalContent('An unexpected error occurred');
            console.error(error);
        } finally {
            setAPILoading(false);
            setApiLoadingMessage("");
        }
    };
  
    const createImageElementandAddToHTML = (apiData) => {
      // Implement your logic for creating an image element and adding it to HTML
    };
  
    const getPopulationData = () => {
      // Implement your logic for fetching population data
    };

    
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // Aqib Code >>>>>>>>>>

    async function CheckCityCountyNameValid(cityCountyName) {
        try {
            const response = await APICom.fetchData("main", "SimulationScheduler/ValidateCityCountyName?cityCountyName="+ cityCountyName, "get", {}, {}, xCancelSourceForGrid.current)
            if(response.data['result'] == "True"){
                if(response.data["VerticesData"] != "" && response.data["VerticesData"] != undefined){
                    setSavedCoordinates(response.data["VerticesData"].toString());
                    return true;
                }
                else{
                    setSavedCoordinates("");
                    return true;
                }
                //return false;
            }
            return false;
            
        } catch (error) {
            console.error('Error validating city county name', error);
            return false;
        }
    };

    
    let stopsKey = 0;
    const passDataToStopsComponent = (stopsData) => {
        try {
            if(stopsData != undefined && stopsData?.length > 0){

            }
        } catch (error) {
            
        }
    }
    const [selectedSavedCitiesOption, setSelectedSavedCitiesOption] = useState('');

    const handleSavedCitites = (event) => {
        //setSelectedOption(event.target.value);

    }; 

    const [isEmailVerficationVisible, setEmailVerificationVisible] = useState(false);
    const handleEmailVerificationVisibility = (isVisible) => {
        setEmailVerificationVisible(isVisible);
    }
   
    const hideEmailVerificationUponCancelClick = () => {
        setEmailVerificationVisible(false);
    }
   
    const [overWritePolygon, setOverWritePolygon] = useState(false);
    useEffect(() => {
        //alert("overWritePolygon:" + overWritePolygon)
    }, [overWritePolygon])

    const [isOverwriteDefaultChecked, setIsOverwriteDefaultChecked] = useState(false);
    useEffect(() => {
        setOverWritePolygon(isOverwriteDefaultChecked);
        
    }, [isOverwriteDefaultChecked])

    const [isTripDetailsVisible, setTripDetailsVisible] = useState(false);
    const toggleVisibilityOfTripDetails = () => {
        setTripDetailsVisible(!isTripDetailsVisible);

      
    };

    useEffect(() => {
        if (name.trim() === '') {
            setTotalStops(0);
            setInsidePolygonStops([]);
            setStopsDataForPopApi([]);
            setIsResetBtnCalled(true);
            setIsBtnDisabled(true)
        } else {
        //   setIsBtnDisabled(false); // Enable the buttons if name is not empty
        }
      }, [name]); // This effect will run whenever the name changes


    const clearPlottedStops = () => {
        setName("");
        // setAPILoading(true);
        // setApiLoadingMessage("Clearing Data");
        // setName("");
        // setTotalStops(0);
        // setInsidePolygonStops([]);
        // setStopsDataForPopApi([]);
        // setIsResetBtnCalled(true);
        // setApiLoadingMessage("Cleared");
        // setAPILoading(false);
        // setIsBtnDisabled(true)
    };
    const handleSearchComplete = () => {
        setIsBtnDisabled(false)
        setAPILoading(false);
        setApiLoadingMessage("");
        setIsSearchBtnClicked(false);
    };

    const handleReloadStops = () => {
        setIsReloadStopsBtnClicked(true);
    };

    const handleDefaultSimulation = () => {
        try {
            window.location.href = DefaultSimulationLink;
        } catch (error) {
            
        }
    }

    const handleReloadStopsBtnComplete = () => {
        setIsReloadStopsBtnClicked(false);
    };

    const handleResetCompleteFromMap = () => {
        try {
            setIsResetBtnCalled(false);
        } catch (error) {
            
        }
    }


    const handleSaveSimulationDetails = (details) => {
        console.log("Simulation Details:", details);

    //     const [numberOfTrips, setNumberOfTrips] = useState(100);
    // const [numberOfVehicles, setNumberOfVehicles] = useState(10);
    // const [slotDuration, setSlotDuration] = useState(60);
    // const [email, setEmail] = useState("");
    
    setNumberOfTrips(details.numberOfTrips)
    setNumberOfVehicles(details.numberOfVehicles)
    setSlotDuration(details.slotDuration)
    };

    const handleEmail = (details) => {
        // console.log("EMail Details:", details);
        setEmail(details)
    };

    useEffect(() => {
        if(email != undefined && email != ""){
            handleStartSimulation();
        }
    },[email])


    // const CreateNewSimulationUser = () => {
    //     let IsRequiredDataAvailable = false;
    //     setSlotMessageOnEmailVerificationScreen("");
    //     if(email != undefined && email != "")
    //     {
    //         setAPILoading(true);
    //         setApiLoadingMessage("Processing your request, Hold on....");
    //         setTimeout(() => {
    //             //setApiLoadingMessage("Processing your request, This will not take much longer");
    //         }, 2000);
    //         console.log("this is after the changes", insidePolygonStops);
    //         const _convertedpolygonVertices = polygonVertices?.map(stop => [stop.lat, stop.lng]);
    //         const _Stops  = insidePolygonStops?.map((stop, index) => { if(stop.name !== ""){return [stop.lat, stop.lon, stop.name, stop.street, stop.state, stop.zip]}else{
    //             return [stop.lat, stop.lon, "Stop " + index, stop.street, stop.state, stop.zip]}
    //         });
    //         let _completeAddress = "";
    //         if(addressComponentDataArray != undefined && addressComponentDataArray[4]?.value != undefined){
    //             _completeAddress = addressComponentDataArray[4].value;
    //         }
    //         // console.log(_completeAddress);
    //         StartSimulation(name, email, numberOfVehicles, numberOfTrips, slotDuration, _Stops, _convertedpolygonVertices, _completeAddress)
            
    //     }
    // };

    const handleStartSimulation = async () =>  {
        let IsRequiredDataAvailable = false;
        setSlotMessageOnEmailVerificationScreen("");

        

       
        if(email != undefined && email != "")
        {
            
            try{

                let data = {
                    "vEmail": email
                }
                let response = await APICom.fetchData("main", "SimulationScheduler/SlotAssignedToUser", "post", {}, data, xCancelSourceForGrid.current)

                if(response.data['result'] == "False"){

                    setSlotMessageOnEmailVerificationScreen(response.data.Message.toString());
                    
                }
                else{
                    setAPILoading(true);
                    setApiLoadingMessage("Processing your request, Hold on....");
                    setTimeout(() => {
                        //setApiLoadingMessage("Processing your request, This will not take much longer");
                    }, 2000);
                    console.log("this is after the changes", insidePolygonStops);
                    const _convertedpolygonVertices = polygonVertices?.map(stop => [stop.lat, stop.lng]);
                    const _Stops  = insidePolygonStops?.map((stop, index) => 
                        { 
                        
                            if(stop.name !== "")
                                
                            {
                                return [stop.lat, stop.lon, stop.name, stop.street, stop.state, stop.zip]
                            }
                                
                            else
                            {
                                return [stop.lat, stop.lon, "Stop " + index, stop.street, stop.state, stop.zip]
                            }
                        });
                    let _completeAddress = "";
                    if(addressComponentDataArray != undefined && addressComponentDataArray[4]?.value != undefined){
                        _completeAddress = addressComponentDataArray[4].value;
                    }
                    // console.log(_completeAddress);
                    StartSimulation(name, email, numberOfVehicles, numberOfTrips, slotDuration, _Stops, _convertedpolygonVertices, _completeAddress)
                    
    
                }
    
            }
            catch (error) {
                console.error('Error Check If Slot Already Assigned', error);
                return false;
            }
             
        }
    };

    function calculateTripsPerDuration(tripsPerHour, durationInMinutes) {
        // Calculate trips per minute
        const tripsPerMinute = tripsPerHour / 60;
        
        // Calculate the number of trips for the given duration
        const numberOfTrips = tripsPerMinute * durationInMinutes;
        
        // Round to the nearest integer and convert to string
        return Math.round(numberOfTrips).toString();
      }


    const StartSimulation = async (name, email, numberOfVehicles, numberOfTrips, slotDuration, stopData, verticesData, AddressComponent) => {
        try{

            let _savedProfileUserName = '';
            let _savedProfileUserPassword = '';
            let _savedProfileAffiliate = '';
            let _savedCustomerProfileId = '';
            let IsRequiredDataAvailable = false;

            let TotalTrips = calculateTripsPerDuration(numberOfTrips, slotDuration);

            let ZoneNameAlter = name.replace(/,/g, ' ');
    


            let  data = {

                "vEmail": String(email),
                "city": ZoneNameAlter,
                "VehiclesCount": numberOfVehicles,
                "vSlotDuration": slotDuration,
                "iNoOfTripsPerVehicle":TotalTrips,
                "stops": stopData,
                "vertices":verticesData,
                "AddressComponent": AddressComponent,
                "bDefaultTemplate": overWritePolygon
            }

            let response = await APICom.fetchData("main", "SimulationScheduler/CustomSimulation", "post", {}, data, xCancelSourceForGrid.current)
            if(response != undefined && response != null)
            {
                if(response?.error != undefined && response?.error == ''){
                    if(response?.data != undefined && response?.data != null && response?.data?.result == "True"){
                        if(response?.data?.vUserName != undefined && response?.data?.vUserName != null && response?.data?.vUserName != ""
                            && response?.data?.vUserPassword != undefined && response?.data?.vUserPassword != null && response?.data?.vUserPassword != ""
                            && response?.data?.iAssignedAffiliateID != undefined && response?.data?.iAssignedAffiliateID != null && response?.data?.iAssignedAffiliateID != ""
                            && response?.data?.iCustomerProfileID != undefined && response?.data?.iCustomerProfileID != null && response?.data?.iCustomerProfileID != ""){
                                _savedProfileUserName = response.data.vUserName;
                                _savedProfileUserPassword = response.data.vUserPassword;
                                _savedProfileAffiliate = response.data.iAssignedAffiliateID;
                                _savedCustomerProfileId = response.data.iCustomerProfileID;
                            IsRequiredDataAvailable = true;
                            setApiLoadingMessage("Please wait, we will redirect you to Simulation Dashborad shortly.....");
                            if(response?.data != undefined && 
                                response?.data?.Message.toString().includes("No free slot is available")){
                                    setApiLoadingMessage(response.data.Message.toString());
                                    setSlotMessageOnEmailVerificationScreen(response.data.Message.toString() + " " + response.data.RemainingMinutes.toString());
                                    IsRequiredDataAvailable = false;
                                }
                        }
                        else if(response?.data != undefined && 
                            response?.data?.Message.toString().includes("No free slot is available")){
                                setApiLoadingMessage(response.data.Message.toString());
                                setSlotMessageOnEmailVerificationScreen(response.data.Message.toString() + " " + response.data.RemainingMinutes.toString());
                                IsRequiredDataAvailable = false;
                        }
                        else{
                            IsRequiredDataAvailable = false;
                        }
                    }
                    else{
                        IsRequiredDataAvailable = false;
                    }
                }
                else{
                    IsRequiredDataAvailable = false;
                }
            }
            else{
                IsRequiredDataAvailable = false;
            }
            setApiLoadingMessage("");
            
            if(IsRequiredDataAvailable == false){
                setAPILoading(false);
            }

            if(IsRequiredDataAvailable == true){
                // Launch Dashboard;
                setSlotMessageOnEmailVerificationScreen("");
                setApiLoadingMessage("Launching Dashboard.....");

                
                //setCountDownLoading(true);
                
                if(_savedCustomerProfileId != undefined && _savedCustomerProfileId != ""){
                    try {
                        setSlotMessageOnEmailVerificationScreen("You will be redirected to MT Dashboard in 30 seconds...");
                        setApiLoadingMessage("");
                        setAPILoading(false);
                        startTimer();
                        await getLoaderMessages(_savedCustomerProfileId, _savedProfileUserName, _savedProfileUserPassword, _savedProfileAffiliate);
                    } catch (error) {
                        
                    }
                }
              

               
            }
            //return IsRequiredDataAvailable;
            // if(response == undefined || response == null || response.data.result == "False"){
            //     setUserMessage(response.data.Message);
            // }
            // else if(response != undefined && response != null && response.data.result == "True" && response.data.Record == "NILL"){
            //     setUserMessage(response.data.Message + response.data.RemainingMinutes);
            // }
            // else{
            //     wrapperUpdateSessionHeartBeat();
            //     handleNext();
            // }
            
        } catch (error) {
            setAPILoading(false)
            console.error('Error validating city county name', error);
            return false;
        }
    };

    const firstTimeout = 5000
    const numberOfCalls = useRef(1);
    const timeoutReferenceForLoader = useRef();
    const getLoaderMessages = async (_iUserProfileID, _savedProfileUserName, _savedProfileUserPassword, _savedProfileAffiliate) => {
        try {
            // let emurl = "https://simrmdashboard.itcurves.us/login.html?username=" + "" + "&password=" + "-1"+ "&webmrms=true&iAffiliateID="+ "-1";
            // let repsone = await APICom.fetchData("main", "SimulationScheduler/SendSimulationRMDashboardLink?customeremail=" + email + "&dashboardlink="+ emurl, "get", {}, {}, xCancelSourceForGrid.current)

            const response = await APICom.fetchData("main", "SimulationScheduler/GetLoaderStatus?iUserProfileID="+ parseInt(_iUserProfileID), "get", {}, {}, xCancelSourceForGrid.current)
            if(response != undefined){
                if(response?.data != undefined && response?.data?.Message != undefined && response?.data?.Message !=""){
                    setApiLoadingMessage(response.data.Message);
                    timeoutReferenceForLoader.current = setTimeout(async() => {
                        numberOfCalls.current += 1;
                        await getLoaderMessages(_iUserProfileID, _savedProfileUserName, _savedProfileUserPassword, _savedProfileAffiliate)
                        if(numberOfCalls.current > 6){
                            clearTimeout(timeoutReferenceForLoader.current);
                            setSlotMessageOnEmailVerificationScreen("Dashboard has been launched, If it is not visible then Allow popup from the browser window");
                            let url = "https://simrmdashboard.itcurves.us/login.html?username=" + _savedProfileUserName + "&password=" + _savedProfileUserPassword + "&webmrms=true&iAffiliateID="+ _savedProfileAffiliate;
                            
                            let params = {
                                "customeremail" : email,
                                "dashboardlink" : url
                            }

                            let response = await APICom.fetchData("main", "SimulationScheduler/SendSimulationRMDashboardLink", "post", {}, params, xCancelSourceForGrid.current)

                            // window.open(url, 'Simulation Dashboard');
                            window.location.href = url;
                            setSavedProfileUserName("");
                            setSavedProfileEncryptedPassword("");
                            stopTimer();
                            resetTimer();
                            setCountDownLoading(false);
                            
                            return;
                        }
                    }, firstTimeout);
                }
            }
        } catch (error) {
            setAPILoading(false)
            stopTimer();
            resetTimer();
            return false;
        }
    }

    /////////////////////// Timer \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\
    const [time, setTime] = useState(30);
    const [isRunning, setIsRunning] = useState(false);

    useEffect(() => {
        let timer;
        
        if (isRunning && time > 0) {
        timer = setInterval(() => {
            setTime(prevTime => prevTime - 1);
        }, 1000); // Decrease by 1 second
        }

        // Clear the interval if time reaches 0 or if the component unmounts
        if (time === 0) {
        setIsRunning(false);
        setCountDownLoading(false);
        }

        return () => clearInterval(timer);
    }, [isRunning, time]);

    // Function to start the timer
    const startTimer = () => {
        setCountDownLoading(true);
        setIsRunning(true);
    };

    // Function to stop the timer
    const stopTimer = () => {
        setCountDownLoading(false);
        setIsRunning(false);
    };

    // Function to reset the timer
    const resetTimer = () => {
        setCountDownLoading(false);
        setIsRunning(false);
        setTime(30);
    };
    //\\\\\\\\\\\\\\\\\\\\\ Timer \/////////////////////////////
    

    return (
         
        <div style={{background:"#434c52", fontFamily: "Roboto"}}>
          
          {countDownLoading && (
            <div id="MTS_Loader">
                <h1 id="LoaderCountDown">{time}</h1>
            </div>
          )}
          { apiLoading && (
            <div id="MTS_Loader">
                    <PropagateLoader
                        color="orange"
                        loading
                        speedMultiplier={2}
                    />
                    <label id="MTS_Loader_Text">{apiLoadingMessage}</label>
                </div>
            )}
           { showGuideSection &&
                ( <div id="MTS_GuideMeDiv">
                    <p id="MTS_GuideMeDiv_ContentSection_1">
                        Microtransit simulation software is a specialized tool designed to model and analyze the operations of microtransit systems, 
                        which are on-demand, flexible transportation services. These systems often include shared rides, shuttles, 
                        and other forms of public transit that adapt to real-time demand.
                    </p>
                </div>
            )}
            <header className="MTMS_Header col-*">
                <div id="MTMS_Header_Div1">
                    <label>Welcome To, ITCurves Microtransit Simulation</label>
                </div>
                <div id="MTMS_Header_Div2">
                    <label>Setup & Configurations</label>
                </div>
                <div id="MTMS_Header_Div3">
                    {/* <button style={{background:"beige", height:"25px", fontSize:"small"}} onClick={onClickGuideMe}>Guide Me!</button> */}
                    {/* <label>Welcome</label> */}
                </div>
            </header>
            <div id="MainDiv_MTMS">
               {/**Left Div */}
              <div id="MainDiv_Internal_LeftDiv" className={`${isSlideLeft ? 'slide-left' : ''}`}>
                {/* <div>
                    <select id="MTMS_SavedCities" value={selectedSavedCitiesOption} onChange={handleSavedCitites}>
                        <option value="" disabled>
                            Saved Cities
                        </option>
                        <option value="option1">Option 1</option>
                        <option value="option2">Option 2</option>
                        <option value="option3">Option 3</option>
                    </select>
                </div> */}
                <div id="MTMS_Internal_LeftDiv_StopsHeader">
                    {/* <label>Routes Section</label>
                    <label id="MTMS_Internal_LeftDiv_StopsHeader_T_SelectedStops">Total - {selectedStops} of {0} </label> */}
                </div>
                <div id="MTMS_Internal_LeftDiv_StopsSection"> 
                    <div id="MTMS_Internal_LeftDiv_StopsHeader">
                        <label>Stops</label>
                        <label id="MTMS_Internal_LeftDiv_StopsHeader_T_SelectedStops">Total Stops- {totalStops} </label>
                    </div>
                    <div id="MTS_Stops_Div">
                        {stopsDataForPopApi?.map((item, s) => (
                                 
                                <MTS_Stops key={stopsKey++} title={(item.name === '' ? "Stop " + stopsKey : item.name ) } latlng={stopsDataForPopApi[s]} _isChecked={true}/>
                         ))}
                    </div>
                </div>
              </div>
              {/**Right Div */}
              <div id="MainDiv_Internal_RightDiv" className={`${isSlideRight ? 'slide-right' : ''}`}>
                
                {/**Search Div */}
                <div id="MDIRD_HeaderSectionDiv">
                    <div id="MDIRD_HSD_StartHere">
                        <label id="MDIRD_HSD_StartHereLabel">Start Here</label>
                        <div id="MDIRD_ToolKitDiv">
                            <div id="MDIRD_TKD_SearchAddress">
                                <input  value={name} onChange={handleInputChange} onKeyDown={(e)=>{if(e.key === "Enter"){e.preventDefault(); getGTFS();}}} id="MDIRD_EntrCityStateSearch" type="text" placeholder="Enter City or Zip..."></input>
                                <div id="MDIRD_DrawAreaMap">
                                    {/* <button style={{background:"lightsalmon"}} onClick={resetSearchCityState}>X</button> */}
                                    <button id="MDIRD_SearchButton" onClick={getGTFS}>Search</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="MDIRD_MakeItAStop">
                        {/* <label>Click anywhere on the Map to make it a Stop</label> */}
                    </div>
                </div>
                
                {/**Map Div */}
                <div id="MDIRD_MapDiv">
                    <RCZControlMap center={{ lat: 38.9769396464269, lng: -76.49387978315518 }} zoom={12}  ref={googleMapComponentRef} initialStops= {stopsDataForPopApi} onSave={onMapDataSave} nameOfCityCounty={name}
                    IsSearchButtonClicked ={isSearchBtnClicked} IsResetBtnClicked={isResetBtnCalled}
                    onSearchComplete={handleSearchComplete} onResetComplete={handleResetCompleteFromMap}
                    plottedStops ={setStopsDataForPopApi} IsReloadStopsButtonClicked = {IsReloadStopsBtnClicked} onReloadStopsComplete = {handleReloadStopsBtnComplete}
                    AddressComponentData = {handleAddressComponentDataFromMap} 
                    SavedPolygone={savedCoordinates}
                    onStopsLoadedFromAPI = {setIsStopsLoadedFromAPI}
                    />
                    <div id="MTMS_Logo_Itcurves_div">
                        <img id="MTMS_Logo_Itcurves" src={itcurvesLogo} />
                    </div>
                    {/* <div id="MTMS_LaunchSimulation_div">
                        <img id="MTMS_LaunchSimulation" src={LaunchSimulationButtonDesign} />
                    </div> */}
                </div>
                
                {/**Start Simulation Button Div */}
                <div id="MDIRD_StartSimulationDiv">
                    <div style={{justifyContent:"flex-start", width:"67%", display:"inline-flex"}}>
                        <button id="MDIRD_StartSimulationButton" onClick={handleDefaultSimulation}>Default Simulation</button>
                    </div>
                    <div style={{display:"inline-flex", width:"33%", display:"flex-end"}}>
                        <button id="MDIRD_StartSimulationButton" onClick={handleReloadStops} disabled={isBtnDisabled}>Recompute Stops</button>
                        <button id="MDIRD_StartSimulationButton" style={{background:"lightsalmon"}} onClick={clearPlottedStops}>Clear All</button>
                        <button id="MDIRD_StartSimulationButton" onClick={toggleVisibilityOfTripDetails} disabled={isBtnDisabled}>Save & Next</button>
                    </div>
                </div>
              </div>
            </div>
            <footer id="MTMS_Footer">
                <label id="MTMS_Footer_Label">Copyrights ITCurves Microtranist Simulation</label>
            </footer>
            {/** Modal for getting trips and vehicles */}
            {isTripDetailsVisible && (
                <div id="MTS_Trips_Information_Div">
                    <MTS_SimulationStartInfo ShowEmailVerification={handleEmailVerificationVisibility} HideSimualationStartInfo={toggleVisibilityOfTripDetails} onSaveSimulationDetails={handleSaveSimulationDetails}></MTS_SimulationStartInfo>
                </div>
            )}
            {isEmailVerficationVisible && (
                <div id="MTS_Trips_Information_Div">
                    <MTS_EmailVerification slotMessage={slotMessageOnEmailVerificationScreen} HideEmailVerificatinDialog={hideEmailVerificationUponCancelClick} 
                    StopsToSave= {insidePolygonStops} ZoneVerticesToSave= {polygonVertices} onSaveEmailDetails={handleEmail} 
                    onStartClick = {handleStartSimulation}
                    overWritePolygone = {setIsOverwriteDefaultChecked}
                    
                    ></MTS_EmailVerification>
                </div>
            )}
            
        </div>
    );
};

export default MicroTransitMySimulation;